import { Location, type UUID } from '@cobliteam/common-types';

export enum OnboardingSteps {
  SCHEDULE_INSTALLATIONS = 'SCHEDULE_INSTALLATIONS',
  INVITE_USERS = 'INVITE_USERS',
  CREATE_VEHICLES = 'CREATE_VEHICLES',
  CREATE_DRIVERS = 'CREATE_DRIVERS',
  ORGANIZE_GROUPS = 'ORGANIZE_GROUPS',
  CONFIGURE_ALERTS = 'CONFIGURE_ALERTS',
  CREATE_GEOFENCES = 'CREATE_GEOFENCES',
  CREATE_CHECKLISTS = 'CREATE_CHECKLISTS',
}

// TODO: refactor backend to use step name instead of id for updates

export const mapStepIdToName = (stepId: UUID) => {
  switch (stepId) {
    case '7250c510-4633-4edb-891f-2009137aa4a4':
      return OnboardingSteps.SCHEDULE_INSTALLATIONS;
    case 'a10466eb-f31d-4cab-a8d6-3c34830ffb5d':
      return OnboardingSteps.INVITE_USERS;
    case '3ba551a7-75f7-426e-8f22-2e8e597bb04d':
      return OnboardingSteps.CREATE_VEHICLES;
    case '94ac8eff-d2c5-4818-b801-bf1bcd35f1e4':
      return OnboardingSteps.CREATE_DRIVERS;
    case '3e37790a-d939-476a-beaf-0bdfd5cfbe5f':
      return OnboardingSteps.ORGANIZE_GROUPS;
    case 'cede7793-e85b-4db9-bde5-bcd50e4b9aeb':
      return OnboardingSteps.CONFIGURE_ALERTS;
    case '7152c1d7-0047-4ea4-ad95-58a471a33bb8':
      return OnboardingSteps.CREATE_GEOFENCES;
    case 'fa8a5faf-178c-415e-9d8c-d59eef19c637':
      return OnboardingSteps.CREATE_CHECKLISTS;
    default:
      return null;
  }
};

const BasicSettingsSteps = {
  i18nKey: 'basic_settings',
  steps: [
    {
      i18nKey: 'schedule_installations',
      url: Location.CRM_SCHEDULE,
      step: OnboardingSteps.SCHEDULE_INSTALLATIONS,
      permissions: ['create-update-delete:crm'],
      id: '7250c510-4633-4edb-891f-2009137aa4a4',
    },
    {
      i18nKey: 'invite_users',
      url: Location.CONFIG_USERS,
      step: OnboardingSteps.INVITE_USERS,
      permissions: ['create-update-delete:users-and-invites'],
      id: 'a10466eb-f31d-4cab-a8d6-3c34830ffb5d',
    },
    {
      i18nKey: 'create_vehicles',
      url: Location.VEHICLES,
      step: OnboardingSteps.CREATE_VEHICLES,
      permissions: ['create-update-delete:vehicle'],
      id: '3ba551a7-75f7-426e-8f22-2e8e597bb04d',
    },
    {
      i18nKey: 'create_drivers',
      url: Location.DRIVER_MANAGEMENT,
      step: OnboardingSteps.CREATE_DRIVERS,
      permissions: ['create-update-delete:driver'],
      id: '94ac8eff-d2c5-4818-b801-bf1bcd35f1e4',
    },
    {
      i18nKey: 'organize_groups',
      url: Location.VEHICLES_GROUPS,
      step: OnboardingSteps.ORGANIZE_GROUPS,
      permissions: ['create-update-delete:vehicle'],
      id: '3e37790a-d939-476a-beaf-0bdfd5cfbe5f',
    },
  ],
};

const AdvancedSettingsSteps = {
  i18nKey: 'advanced_settings',
  steps: [
    {
      i18nKey: 'configure_alerts',
      url: Location.FLEET_POLICY,
      step: OnboardingSteps.CONFIGURE_ALERTS,
      permissions: ['config-and-view:custom-alerts'],
      id: 'cede7793-e85b-4db9-bde5-bcd50e4b9aeb',
    },
    {
      i18nKey: 'create_geofences',
      url: Location.GEOFENCES,
      step: OnboardingSteps.CREATE_GEOFENCES,
      permissions: ['create-update-delete:places-of-interest'],
      id: '7152c1d7-0047-4ea4-ad95-58a471a33bb8',
    },
    {
      i18nKey: 'create_checklists',
      url: Location.CHECKLIST,
      step: OnboardingSteps.CREATE_CHECKLISTS,
      permissions: ['full-control:checklist'],
      id: 'fa8a5faf-178c-415e-9d8c-d59eef19c637',
    },
  ],
};

export const OnboardingStepsList = [BasicSettingsSteps, AdvancedSettingsSteps];
